import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2edb2486&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2edb2486&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edb2486",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2edb2486')) {
      api.createRecord('2edb2486', component.options)
    } else {
      api.reload('2edb2486', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2edb2486&scoped=true", function () {
      api.rerender('2edb2486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/storageReport/index.vue"
export default component.exports